import { render, staticRenderFns } from "./senior-form.vue?vue&type=template&id=9b5ed91a&scoped=true&"
import script from "./senior-form.vue?vue&type=script&lang=js&"
export * from "./senior-form.vue?vue&type=script&lang=js&"
import style0 from "./senior-form.vue?vue&type=style&index=0&lang=css&"
import style1 from "./senior-form.vue?vue&type=style&index=1&id=9b5ed91a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5ed91a",
  null
  
)

export default component.exports